import React, { Component } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

class CloneModal extends Component {
  state = {
    skuCode: '',
    size: '',
    isNewSku: false,
    isNewSize: false
  };

  componentDidUpdate(prevProps) {
    if (prevProps.product !== this.props.product && this.props.product) {
      this.setState({
        skuCode: this.props.product.sku_code || '',
        size: this.props.product.size || '',
        isNewSku: false,
        isNewSize: false
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit({
      skuCode: this.state.skuCode,
      size: this.state.size
    });
  };

  handleSkuChange = (e) => {
    const value = e.target.value;
    if (value === 'new') {
      this.setState({ isNewSku: true, skuCode: '' });
    } else {
      this.setState({ isNewSku: false, skuCode: value });
    }
  };

  handleSizeChange = (e) => {
    const value = e.target.value;
    if (value === 'new') {
      this.setState({ isNewSize: true, size: '' });
    } else {
      this.setState({ isNewSize: false, size: value });
    }
  };

  render() {
    const { show, onHide, product } = this.props;
    const { skuCode, size, isNewSku, isNewSize } = this.state;

    const sizeOptions = ['M', 'L', 'XL', 'XXL'];

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Clone Product</Modal.Title>
        </Modal.Header>
        <Form onSubmit={this.handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>SKU Code</Form.Label>
              {isNewSku ? (
                <Form.Control
                  type="text"
                  value={skuCode}
                  onChange={(e) => this.setState({ skuCode: e.target.value })}
                  placeholder="Enter new SKU code"
                  required
                />
              ) : (
                <Form.Select
                  value={skuCode}
                  onChange={this.handleSkuChange}
                  required
                >
                  <option value="">Select SKU</option>
                  {product && <option value={product.sku_code}>{product.sku_code}</option>}
                  <option value="new">+ Add New SKU</option>
                </Form.Select>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Size</Form.Label>
              {isNewSize ? (
                <Form.Control
                  type="text"
                  value={size}
                  onChange={(e) => this.setState({ size: e.target.value })}
                  placeholder="Enter custom size"
                  required
                />
              ) : (
                <Form.Select
                  value={size}
                  onChange={this.handleSizeChange}
                  required
                >
                  <option value="">Select Size</option>
                  {sizeOptions.map((sizeOption) => (
                    <option key={sizeOption} value={sizeOption}>
                      {sizeOption}
                    </option>
                  ))}
                  <option value="new">+ Add Custom Size</option>
                </Form.Select>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Clone
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default CloneModal; 